import { RouterModule, Routes } from '@angular/router';

import { BDCPProductFinderResultsComponent } from './pages/results/results.page';
import { BDCPProductFinderRootComponent } from './pages/root/root.page';
import { NgModule } from '@angular/core';

export const BDCPProductFinderRoutes: Routes = [
    {
        path: '',
        component: BDCPProductFinderRootComponent
    },
    {
        path: 'results',
        component: BDCPProductFinderResultsComponent
    },
    {
        path: 'alternatives/:puid',
        component: BDCPProductFinderResultsComponent
    },
    {
        path: 'search/:searchValue',
        component: BDCPProductFinderResultsComponent
    },
    {
        path: 'category/:category',
        component: BDCPProductFinderResultsComponent
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forChild(BDCPProductFinderRoutes)],
    exports: [RouterModule]
})
export class BDCPProductFinderRoutingModule { }
